<template>
  <div class="base-info">
    <div class="base-top flex">
      <div class="columns columns-one">
        <div class="row">
          <div class="row-item flex aling-center">
            <div class="item-label">
              项目名称：
            </div>
            <div class="item-value">
              <el-tooltip
                effect="dark"
                :content="form.projectName"
                placement="top"
              >
                <div class="supplier-add">
                  {{ form.projectName }}
                </div>
              </el-tooltip>
            </div>
          </div>
          <div class="row-item flex">
            <div class="item-label">
              订单分类：
            </div>
            <div class="item-value">
              {{ form.orderType }}
            </div>
          </div>
          <div class="row-item flex">
            <div class="item-label">
              供货单位电话(甲方)：
            </div>
            <div class="item-value">
              {{ form.supplyPhone }}
            </div>
          </div>
          <div class="row-item flex mb-20">
            <div class="item-label">
              客户签约类型：
            </div>
            <div class="item-value">
              {{ form.customerContractType }}
            </div>
          </div>
          <div class="row-item is-required-row flex aling-center mb-15">
            <div class="item-label is-required">
              区域商务专员：
            </div>
            <div class="item-value">
              <el-select
                v-model="form.assistantName"
                placeholder="请选择"
                filterable
                remote
                :remote-method="remoteMethod"
                :disabled="
                  title.includes('退货合同') || title.includes('价外费用合同')
                "
                :loading="loading"
                @change="selectAssignment"
              >
                <el-option
                  v-for="item in commercialSpecialist"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
          <div class="row-item is-required-row flex aling-center mb-15 row-one">
            <div class="item-label is-required">
              订单类型：
            </div>
            <div class="item-value">
              <el-select
                v-model="formDataDetail.postOrdetypeName"
                placeholder="请选择"
                :loading="loading"
                :disabled="
                  title.includes('退货合同')
                "
                @focus="selectOrderType"
              >
                <el-option
                  v-for="item in orderTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
          <div class="row-item flex aling-center mb-20 row-one">
            <div class="item-label">
              销往区域：
            </div>
            <div class="item-value">
              {{ form.salesArea }}
            </div>
          </div>
          <div class="row-item is-required-row flex aling-center mb-20 row-one">
            <div class="item-label is-required">
              结算方式：
            </div>
            <div class="item-value">
              <el-radio-group
                v-model="form.salesSettlementModes"
                :disabled="title.includes('退货合同')"
              >
                <el-radio :label="1">
                  现销
                </el-radio>
                <el-radio :label="2">
                  赊销
                </el-radio>
                <el-radio :label="3">
                  LC
                </el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="row-item flex aling-center">
            <div class="item-label">
              远期时间：
            </div>
            <div class="item-value">
              {{ form.sightDate }}
            </div>
          </div>
          <div v-if="title === '换货合同'" class="row-item flex aling-center">
            <div class="item-label">
              使用返利金额：
            </div>
            <div class="item-value">
              <!-- 退货合同 -->
              <!-- <span v-if="title === '退货合同'">{{
                formDataDetail.refundRebate
              }}</span> -->
              <!-- 换货合同 -->
              <span>{{ formDataDetail.useRebateAmount }}</span>
            </div>
          </div>
          <div v-if="title === '退货合同'" class="row-item flex aling-center">
            <div class="item-label">
              退还返利金额：
            </div>
            <div class="item-value">
              {{ formDataDetail.refundRebate }}
            </div>
            <div v-if="!formDataDetail.isReleaseRebate&& formDataDetail.refundRebate !==0" class="item-value">
              <el-button type="primary" @click="onShowDialog">
                退还返利
              </el-button>
            </div>
          </div>
          <div class="row-item flex aling-center">
            <div class="item-label">
              目的地：
            </div>
            <div class="item-value">
              {{ form.destination }}
            </div>
          </div>
          <div class="row-item flex aling-center">
            <div class="item-label">
              业务类型：
            </div>
            <div class="item-value">
              {{ form.projectType }}
            </div>
          </div>
          <div class="row-item flex aling-center mb-15">
            <div class="item-label">
              原退货单总返利金额：
            </div>
            <div class="item-value">
              {{ form.originallyRebateAmount }}
            </div>
          </div>
        </div>
      </div>
      <div class="columns columns-two">
        <div class="row-item flex aling-center">
          <div class="item-label">
            订单日期：
          </div>
          <div class="item-value">
            {{ form.createdTime }}
          </div>
        </div>
        <div class="row-item flex aling-center">
          <div class="item-label">
            供货单位(甲方)：
          </div>
          <div class="item-value">
            {{ form.supplyUnit }}
          </div>
        </div>
        <div class="row-item flex aling-center">
          <div class="item-label">
            订货单位(乙方)：
          </div>
          <div class="item-value">
            {{ formData.orderUnitName }}
          </div>
        </div>
        <div class="row-item flex aling-center">
          <div class="item-label">
            区域：
          </div>
          <div class="item-value">
            {{ form.regionName }}
          </div>
        </div>
        <div class="row-item flex aling-center">
          <div class="item-label">
            售前姓名：
          </div>
          <div class="item-value">
            {{ form.preSalesPersonName }}
          </div>
        </div>
        <div class="row-item flex aling-center">
          <div class="item-label">
            计量计点：
          </div>
          <div class="item-value">
            <span v-if="form.meteringPoint === 1">计量计点</span>
            <span v-if="form.meteringPoint === 2">计量不计点</span>
            <span v-if="form.meteringPoint === 3">不计量不计点</span>
          </div>
        </div>
        <div class="row-item is-required-row flex aling-center mb-20">
          <div class="item-label is-required">
            电源线规格(2pin)：
          </div>
          <div class="item-value">
            <el-select
              v-model="form.powerCordSpecification"
              :loading="loading"
              placeholder="请选择"
              :disabled="
                title.includes('退货合同') || title.includes('价外费用合同')
              "
              @focus="selectPowerCordSpecification"
            >
              <el-option
                v-for="item in powerLine2pin"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
        </div>
        <div class="row-item is-required-row flex aling-center mb-20">
          <div class="item-label is-required">
            账期：
          </div>
          <div class="item-value">
            <el-input
              v-model="formData.accountPeriod"
              :maxlength="20"
              :disabled="
                title.includes('退货合同') || title.includes('价外费用合同')
              "
            />
          </div>
        </div>
        <div class="row-item flex aling-center">
          <div class="item-label">
            项目代码(CRM编号)：
          </div>
          <div class="item-value">
            {{ form.opportunityCode }}
          </div>
        </div>
        <div class="row-item flex aling-center">
          <div class="item-label">
            细分市场：
          </div>
          <div class="item-value">
            {{ form.marketSegmentName }}
          </div>
        </div>
        <div class="row-item flex aling-center">
          <div class="item-label">
            齐套通知打款邮箱：
          </div>
          <div class="item-value">
            {{ formDataDetail.setNoticeMail }}
          </div>
        </div>
        <div class="row-item flex aling-center">
          <div class="item-label">
            是否返现金点：
          </div>
          <div class="item-value">
            {{ form.cashbackPoints ? "是" : "否" }}
          </div>
        </div>
        <div
          v-if="title !== '罚金合同'"
          class="row-item flex aling-center mb-15"
        >
          <div class="item-label">
            {{
              title === "退货合同(已发货)"
                ? "退货合同(已发货)合同编号："
                : title === "退货合同(未发货)"
                  ? "退货合同(未发货)合同编号："
                  : "换货合同编号："
            }}
          </div>
          <div class="item-value">
            {{ form.newContractNum }}
          </div>
        </div>
      </div>
      <div class="columns columns-three">
        <div
          v-if="title !== '罚金合同'"
          class="row-item flex aling-center mb-20"
        >
          <div class="item-label">
            退换货申请单号：
          </div>
          <div class="item-value">
            {{ form.orderNum }}
          </div>
        </div>
        <div v-else class="row-item flex aling-center mb-20">
          <div class="item-label">
            电子合同编号(申请单号)：
          </div>
          <div class="item-value">
            {{ form.orderNum }}
          </div>
        </div>
        <div class="row-item flex aling-center mb-20 box-tops">
          <div class="item-label">
            币种：
          </div>
          <div class="item-value">
            {{ form.currencyName }}
          </div>
        </div>
        <div class="row-item flex aling-center">
          <div class="item-label">
            订货单位电话(乙方)：
          </div>
          <div class="item-value">
            {{ formData.orderUnitTel }}
          </div>
        </div>
        <div class="row-item flex aling-center">
          <div class="item-label">
            二级渠道名称：
          </div>
          <div class="item-value">
            {{ form.secondChannelName }}
          </div>
        </div>
        <div class="row-item flex aling-center">
          <div class="item-label">
            外销姓名：
          </div>
          <div class="item-value">
            {{ form.salesPersonName }}
          </div>
        </div>
        <div class="row-item flex aling-center">
          <div class="item-label">
            贸易方式：
          </div>
          <div class="item-value">
            {{ form.tradeTerm }}
          </div>
        </div>
        <div class="row-item is-required-row flex aling-center mb-20">
          <div class="item-label is-required">
            电源线规格(3pin)：
          </div>
          <div class="item-value">
            <el-select
              v-model="form.threePlugPowerCord"
              :loading="loading"
              placeholder="请选择"
              :disabled="
                title.includes('退货合同') || title.includes('价外费用合同')
              "
              @focus="selectPowerCordSpecification"
            >
              <el-option
                v-for="item in powerLine3pin"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
        </div>
        <div class="row-item is-required-row flex aling-center mb-20">
          <div class="item-label is-required">
            净销售额：
          </div>
          <div class="item-value">
            <el-input
              v-model="formDataDetail.netSales"
              :maxlength="20"
              :disabled="
                title.includes('退货合同') || title.includes('价外费用合同')
              "
            />
          </div>
        </div>
        <div class="row-item flex aling-center">
          <div class="item-label">
            借条单号：
          </div>
          <div class="item-value">
            {{ form.borrowingOrderNumber }}
          </div>
        </div>
        <div class="row-item flex aling-center mb-20">
          <div class="item-label">
            应用场合：
          </div>
          <div class="item-value">
            {{ form.applicationScenariosName }}
          </div>
        </div>
        <div class="row-item is-required-row flex aling-center mb-20">
          <div class="item-label is-required">
            税率：
          </div>
          <div class="item-value">
            {{ form.formTaxRate }}
            <!-- 退货合同 -->
            <!-- <span v-if="title.includes('退货合同')">{{ form.formTaxRate }}</span> -->
            <!-- 换货合同 -->
            <!-- <template v-if="title.includes('换货合同')||title.includes('价外费用合同')">
              <el-input
                v-model="formDataDetail.taxRate"
                :maxlength="10"
              />
            </template> -->
          </div>
        </div>
        <div class="row-item flex aling-center mb-15">
          <div class="item-label">
            现金点比例：
          </div>
          <div class="item-value">
            {{ form.cashPointRatio }}
          </div>
        </div>
        <div
          v-if="title !== '罚金合同' && title.includes('换货合同')"
          class="row-item is-required-row flex aling-center mb-15"
        >
          <div class="item-label">
            仓库：
          </div>
          <div class="item-value">
            <el-select
              v-model="form.warehouse"
              placeholder="请选择"
              :loading="loading"
              @focus="currencyQuery()"
            >
              <el-option label="" value="" />
              <el-option
                v-for="item in currencyList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
        </div>
      </div>
      <div class="columns columns-four">
        <div v-if="title !== '罚金合同'" class="row-item flex aling-center">
          <div class="item-label">
            原客户合同编号：
          </div>
          <div class="item-value">
            {{ form.oldContractNum }}
          </div>
        </div>
        <div v-else class="row-item flex aling-center">
          <div class="item-label">
            客户合同编号：
          </div>
          <div class="item-value">
            {{ form.newContractCustomerNum }}
          </div>
        </div>
        <div class="row-item flex aling-center">
          <div class="item-label">
            供货单位地址：
          </div>
          <div class="item-value">
            <el-tooltip
              effect="dark"
              :content="form.supplyAddress"
              placement="top"
            >
              <div class="supplier-add">
                {{ form.supplyAddress }}
              </div>
            </el-tooltip>
          </div>
        </div>
        <div class="row-item flex aling-center">
          <div class="item-label">
            最终客户：
          </div>
          <div class="item-value">
            {{ formData.finalCustomerName }}
          </div>
        </div>
        <div class="row-item flex aling-center">
          <div class="item-label">
            二级渠道类型：
          </div>
          <div class="item-value">
            {{ form.secondChannelType }}
          </div>
        </div>
        <div class="row-item flex aling-center">
          <div class="item-label">
            部门：
          </div>
          <div class="item-value">
            {{ form.salesPersonDeptName }}
          </div>
        </div>
        <div class="row-item flex aling-center mb-20">
          <div class="item-label">
            运输方式：
          </div>
          <div class="item-value">
            {{ form.modeOfShipping }}
          </div>
        </div>
        <div
          class="row-item is-required-row flex aling-center mb-15 box-top-one"
        >
          <div class="item-label is-required">
            发货方式：
          </div>
          <div class="item-value">
            <el-radio-group
              v-model="form.shipType"
              :disabled="
                title.includes('退货合同') || title.includes('价外费用合同')
              "
            >
              <el-radio :label="1">
                齐套发货
              </el-radio>
              <el-radio :label="2">
                分批发货
              </el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="row-item is-required-row flex aling-center">
          <div class="item-label is-required">
            即期/远期：
          </div>
          <div class="item-value">
            <el-radio-group
              v-model="form.atAfterSight"
              :disabled="
                title.includes('退货合同') || title.includes('价外费用合同')
              "
            >
              <el-radio :label="1">
                即期
              </el-radio>
              <el-radio :label="2">
                远期
              </el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="row-item flex aling-center box-tops">
          <div class="item-label">
            CRM客户编码：
          </div>
          <div class="item-value">
            {{ form.crmAccountCode }}
          </div>
        </div>

        <div class="row-item flex aling-center">
          <div class="item-label">
            云桌面授权邮箱：
          </div>
          <div class="item-value">
            {{ form.authorizationEmail }}
          </div>
        </div>
        <div class="row-item flex aling-center">
          <div class="item-label">
            采购类型：
          </div>
          <div class="item-value">
            {{ form.purchaseType }}
          </div>
        </div>
        <div class="row-item flex aling-center">
          <div class="item-label">
            退换货原因：
          </div>
          <div class="item-value">
            <!-- D8：落库值（如“产品发运错误”）经 displayReasonType 映射后再展示 -->
            {{ displayReasonType(form.reasonType) }}
          </div>
        </div>
      </div>
    </div>
    <div class="base-bottom">
      <div class="row-item flex aling-center">
        <div class="item-label">
          补充条款：
        </div>
        <div class="item-value flex1">
          <el-input
            v-model="form.supplementalTerm"
            placeholder="请输入内容"
            :maxlength="200"
          />
        </div>
      </div>
      <div class="row-item flex aling-center">
        <div class="item-label">
          服务条款：
        </div>
        <div class="item-value flex1">
          <el-input
            v-model="formDataDetail.serviceTerm"
            :maxlength="200"
            placeholder="请输入内容"
          />
        </div>
      </div>
      <div class="row-item flex aling-center">
        <div class="item-label">
          收货回执及到货验收要求：
        </div>
        <div class="item-value flex1">
          <el-input
            v-model="formDataDetail.specialRemarks"
            :maxlength="200"
            placeholder="请输入内容"
          />
        </div>
      </div>
      <div class="row-item flex aling-center">
        <div class="item-label">
          备注说明：
        </div>
        <div class="item-value flex1">
          <el-input
            v-model="form.remarks"
            :maxlength="200"
            placeholder="请输入内容"
          />
        </div>
      </div>
    </div>
    <!-- 退还返利组件 -->
    <refundRebateReasonsDialog ref="refundRebateReasonsDialogRefs" @refreshData="doSearch" />
  </div>
</template>
<script>
import { dictgetDictData, getAssistantInfo, getOrderTypesBySupplyUnit, getCountryOrSpecificationPowerCord } from '@/API';
import refundRebateReasonsDialog from './refundRebateReasonsDialog.vue';
import { displayReasonType } from '@/constant';
export default {
  props: {
    // 合同信息表单
    form: {
      type: Object,
      default: () => { }
    },
    // 订货单位/最终客户
    formData: {
      type: Object,
      default: () => { }
    },
    // 输入框绑定字段
    formDataDetail: {
      type: Object,
      default: () => { }
    },
    // 合同类型
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      visible: false,
      // 商务专员下拉数据
      commercialSpecialist: [],
      // 订单类型数据
      orderTypeList: [],
      // 币种数据--仓库数据
      currencyList: [],
      // 电源线规格2
      powerLine2pin: [],
      // 电源线规格3
      powerLine3pin: []
    };
  },
  components: {
    refundRebateReasonsDialog
  },
  watch: {
    form: {
      handler (nextValue) {
        if (this.$props.title === '换货合同') {
          this.$props.props.form.shipType = nextValue.shipType ?? 1;
          this.$props.props.form.atAfterSight = nextValue.atAfterSight ?? 1;
        }
        if (this.$props.title === '价外费用合同') {
          this.$props.form.atAfterSight = nextValue.atAfterSight ?? 1;
          this.$props.form.netSales = nextValue.netSales ?? 0;
          this.$props.form.shipType = nextValue.shipType ? nextValue.shipType : 1;
        }
      },
      deep: true
    }
  },
  methods: {
    // D8：退换货原因展示名映射（落库值保持不变，仅展示层生效）
    displayReasonType,
    onShowDialog () {
      this.$refs.refundRebateReasonsDialogRefs.showDialog();
    },
    // 刷新父组件数据
    doSearch () {
      this.$emit('refreshData');
    },
    // 仓库数据获取
    currencyQuery () {
      this.loading = true;
      let params = { dictType: 'Warehouse' };
      dictgetDictData(params).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.currencyList = json.data.map((item) => ({
            value: item.dictValue
          }));
        }
      }).catch((err) => {
        console.log(err);
        this.loading = false;
      });
      this.loading = false;
    },
    // 商务专员下拉数据
    remoteMethod (query) {
      this.loading = true;
      getAssistantInfo(query).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.commercialSpecialist = json.data.map((item) => ({
            value: item.assistantUserID,
            label: item.assistantUserName
          }));
        }
      }).catch((err) => {
        console.log(err);
        this.loading = false;
      });
      this.loading = false;
    },
    // 区域商务选中赋值
    selectAssignment (value) {
      const selectedItem = this.currencyList.find(item => item.value === value);
      this.form.assistantCode = selectedItem.value;
      this.form.assistantName = selectedItem.label;
    },
    // 订单类型
    selectOrderType () {
      this.loading = true;
      getOrderTypesBySupplyUnit(this.form.supplyUnitId, this.form.currencyType).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.orderTypeList = json.data.map((item) => ({
            value: item.basicInfoName
          }));
        }
      }).catch(() => { });
      this.loading = false;
    },
    // 电源线规格
    selectPowerCordSpecification () {
      this.loading = true;
      getCountryOrSpecificationPowerCord(this.form.salesArea).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.powerLine2pin = json.data.twoPinPowerCordList.map((item) => ({
            value: item.constantName
          }));
          this.powerLine3pin = json.data.threePinPowerCordList.map((item) => ({
            value: item.constantName
          }));
        }
      }).catch(() => { });
      this.loading = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.row-one {
  margin: 0 0 26px 0 !important;
}
.base-info {
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;
  margin-top: 12px;
  .base-top,
  .base-bottom {
    justify-content: space-between;
    .row-item {
      margin-bottom: 26px;
      font-size: 14px;
      color: #505050;
      .supplier-add {
        max-width: 250px;
        overflow: hidden;
        text-overflow: ellipsis;
        text-wrap: nowrap;
      }
      // 必填项样式
      .is-required {
        position: relative;
        &::after {
          content: "*";
          position: absolute;
          left: -10px;
          top: 50%;
          transform: translateY(-50%);
          color: #d43030;
        }
      }
    }
    .is-required-row {
      padding-left: 8px;
    }
    .mb-15 {
      margin-bottom: 15px;
    }
    .mb-20 {
      margin-bottom: 20px;
    }
  }
  .base-top {
    .columns {
      width: 25%;
    }
  }
  .base-bottom {
    .row-item {
      margin-bottom: 15px;
    }
  }
}
.base-top {
  .item-value {
    flex-grow: 1;
    ::v-deep .el-select,
    .el-input {
      width: 85%;
    }
    ::v-deep .el-input--mini .el-input__inner {
      height: 32px;
      line-height: 32px;
      border-color: #e4e4e4;
      color: #505050;
    }
    ::v-deep .el-radio__label {
      padding-left: 5px;
    }
    ::v-deep .el-radio {
      margin-right: 15px;
    }
    ::v-deep .el-radio__input.is-checked .el-radio__inner {
      background: #fff;
    }
    ::v-deep .el-radio__inner::after {
      width: 7px;
      height: 7px;
      background-color: #409efe;
    }
    ::v-deep .el-radio__input.is-checked + .el-radio__label {
      color: #505050;
    }
  }
}
.base-bottom {
  .row-item {
    .item-value {
      ::v-deep .el-input--mini .el-input__inner {
        border-color: #e4e4e4;
        color: #a6a6a6;
        width: 100%;
      }
    }
  }
}
.flex {
  display: flex;
}
.flex1 {
  flex: 1;
}
.aling-center {
  align-items: center;
}
.box-tops {
  margin: 26px 0 26px 0 !important;
}
.box-top-one {
  margin: 30px 0 26px 0 !important;
}
</style>
